<template>
    <b-form-group :class="{ 'is-invalid-group': hasError }">
        <label v-if="label">
            {{ label }}
            <span class="field-required-mark">*</span>
        </label>
        <b-form-radio-group
            :value="value"
            :options="options"
            :name="radioGroupName"
            @input="onInput"
        />
        <span v-if="hasError" class="field-error">{{ errorMessage }}</span>
    </b-form-group>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: 'Debe seleccionar una opción',
        },
        name: {
            type: String,
            default: '',
        },
    },
    computed: {
        radioGroupName() {
            return this.name || `fssc-boolean-${this._uid}`
        },
    },
    data() {
        return {
            options: [
                { text: 'Sí', value: '1' },
                { text: 'No', value: '0' },
            ],
        }
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
    },
}
</script>

<style scoped>
.is-invalid-group .custom-control-label {
    color: inherit;
}
</style>
